import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  raffles: [],
  selectedRaffle: null,
  prize_list: [],
  my_tickets: [],
  ticket_list: [],
  won_list: [],
  campains: [],
  campain: {},
};

export const raffleSlice = createSlice({
  name: 'raffle',
  initialState,
  reducers: {
    addRaffle: (state, action) => {
      state.raffles.push(action.payload);
    },

    setRaffleContests: (state, action) => {
      state.won_list = action.payload;
    },
    setRaffleCamplainList: (state, action) => {
      state.campains = action.payload;
    },
    setRaffleCampainMyTickets: (state, action) => {
      const groupByCreatedAt = (data) => {
        const groupedMap = data.reduce((map, item) => {
          const date = item.created_at.split('T')[0];
          if (!map.has(date)) {
            map.set(date, []);
          }
          map.get(date).push({
            id: item.id,
            ticketNo: item.ticket_number,
            status: item.status,
          });
          return map;
        }, new Map());

        return Array.from(groupedMap, ([date, prizes]) => ({ date, prizes }));
      };
      state.my_tickets = groupByCreatedAt(action.payload);
    },
    setRaffleCamplainPrizeList: (state, action) => {
      const restructurData = (results = []) => {
        const groupedMap = results.reduce((map, campaign) => {
          const formattedDate = new Date(campaign?.start_date)
            ?.toISOString()
            ?.split('T')[0];

          if (!map.has(formattedDate)) {
            map.set(formattedDate, []);
          }

          const tickets = campaign.winning_tickets.map((ticket) => ({
            id: ticket.id,
            ticketNo: ticket.ticket_number,
            amount: ticket.prize_amount || 0,
          }));

          map.get(formattedDate).push(...tickets);
          return map;
        }, new Map());

        return Array.from(groupedMap, ([date, tickets]) => ({ date, tickets }));
      };

      state.prize_list = restructurData(action.payload);
    },

    selectRaffle: (state, action) => {
      state.selectedRaffle =
        state.raffles.find((raffle) => raffle.id === action.payload.id) || null;
    },

    clearSelectedRaffle: (state) => {
      state.selectedRaffle = null;
    },
  },
});

export const {
  addRaffle,
  setRaffleContests,
  selectRaffle,
  clearSelectedRaffle,
  setRaffleCamplainList,
  setRaffleCampainMyTickets,
  setRaffleCamplainPrizeList,
} = raffleSlice.actions;

export default raffleSlice.reducer;
